import styled from "styled-components";
export const MergeUnitsHistoryContainer = styled.div.withConfig({
  displayName: "merge-units-historystyles__MergeUnitsHistoryContainer",
  componentId: "sc-ks4l1o-0"
})([""]);
export const MergeUnitsHistoryContent = styled.div.withConfig({
  displayName: "merge-units-historystyles__MergeUnitsHistoryContent",
  componentId: "sc-ks4l1o-1"
})(["", ""], {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "1rem"
});
export const MergeUnitsHistoryHeader = styled.div.withConfig({
  displayName: "merge-units-historystyles__MergeUnitsHistoryHeader",
  componentId: "sc-ks4l1o-2"
})(["", ""], {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "1rem",
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem"
});
